import { View } from 'backbone.marionette';
import template from './index.jst';
import './index.styl';

export class RoundStatItem extends View {
	get template() {
		return template;
	}

	get className() {
		return 'match-centre-row player-stats';
	}

	initialize() {
		this.model.set( {
			'squads_logos': process.env.SQUAD_LOGOS_PATH,
			'headings': this.options.match_stat.match_stats_headings,
			is_bye: this.model.get('is_bye') || false
		} );
		const matchStats = this.model.attributes.match_stats.match_stats;
		const new_match_points = {
			...this.model.attributes.match_stats.match_points,
			['OF']:  matchStats['OFG'] * 2 + matchStats['OFH'] * 4,
		}
		this.model.set({
			match_stats: {
				match_stats: matchStats,
				match_points: new_match_points
			}
		})
		
	}
}

export default RoundStatItem;